import { Component, Input } from '@angular/core';
import { Message } from '@obo-main/components/chatBot/DTO/Conversation';
import { NgClass } from '@angular/common';
import { MarkdownComponent } from 'ngx-markdown';

@Component({
    selector: 'app-chatbot-message',
    standalone: true,
    imports: [NgClass, MarkdownComponent],
    templateUrl: './message.component.html',
    styleUrl: './message.component.scss'
})
export class MessageComponent {
    @Input()
    public message: Message;

    constructor() {}
}
